/**
 * Motion picks (Stage 4, 2026-10-20). Each animation ships with a default; in a dev build the URL can choose another so
 * /lab/motion can run every candidate in the real app side by side:
 *   ?orbs=<variant>      the background orb field (AmbientOrbField)
 *   ?launch=<variant>    the launch splash (LaunchSplash); &ready=<ms> holds the app "not ready" that long
 *   ?mapload=<variant>   the Maps loader (MapLoader); &hold=<ms> keeps it up at least that long
 *   ?loader=<variant>    the page loader (PetalLoader)
 *   ?page=<variant>      how a page arrives when you change pages (lib/pageTransition)
 *   ?dock=<variant>      how the tab dock moves to a new tab (Header)
 *   ?cam=x,z,r,theta,phi a map opens at this camera (dev; the lab's map frames)
 *   ?tour=1              Layout walks the dock's tabs by itself (the lab's page-change frames)
 * Read once per page load. In production the params are ignored and the defaults below apply.
 */
// Sam's picks (2026-10-20): Sparkle, quicker and fuller for the background; Spring with the name from the start (L3) for the launch; three petals going
// round over the bar for Maps, and three going round for pages.
export const MOTION_DEFAULTS = {
  orbs: 'sparkleWander',
  launch: 'springName',
  mapload: 'comet',
  loader: 'off',
  page: 'slide',
  dock: 'spring',
}; // page: Slide (T2), dock: Spring (D1) - Sam's picks 2026-10-21   // loader: off in the live app (Sam); /lab/motion still runs it   // launch: L3, the name there from the start

let flags = null;
export function motionFlags() {
  if (flags) return flags;
  flags = { ...MOTION_DEFAULTS, ready: 0, hold: 0, tour: false, cam: null };
  if (!import.meta.env.DEV || typeof window === 'undefined') return flags;
  const q = new URLSearchParams(window.location.search);
  for (const k of ['orbs', 'launch', 'mapload', 'loader', 'page', 'dock'])
    if (q.get(k)) flags[k] = q.get(k);
  flags.ready = Math.max(0, Number(q.get('ready')) || 0);
  flags.hold = Math.max(0, Number(q.get('hold')) || 0);
  flags.tour = q.get('tour') === '1';
  const cam = (q.get('cam') || '').split(',').map(Number);
  if (cam.length === 5 && cam.every(Number.isFinite))
    flags.cam = { x: cam[0], z: cam[1], radius: cam[2], theta: cam[3], phi: cam[4] };
  return flags;
}
